import { useState } from 'react';

/** Team logo; renders nothing when the team has none or it fails to load. */
export function TeamCrest({ logoUrl, size = 20, className = '' }: { logoUrl?: string | null; size?: number; className?: string }) {
  const [broken, setBroken] = useState<string | null>(null);
  if (!logoUrl || broken === logoUrl) return null;
  return (
    <img
      src={logoUrl}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      className={`inline-block shrink-0 object-contain align-middle ${className}`}
      style={{ width: size, height: size }}
      onError={() => setBroken(logoUrl)}
    />
  );
}

export function MatchupLabel({
  home, away, homeLogo, awayLogo, size = 18, className = '',
}: {
  home: string;
  away: string;
  homeLogo?: string | null;
  awayLogo?: string | null;
  size?: number;
  className?: string;
}) {
  return (
    <span className={`inline-flex flex-wrap items-center gap-1.5 ${className}`}>
      <TeamCrest logoUrl={homeLogo} size={size} />
      {home}
      <span className="text-slate-500">vs</span>
      <TeamCrest logoUrl={awayLogo} size={size} />
      {away}
    </span>
  );
}
